module.exports = __webpack_public_path__ + "static/media/vehicle13.85f17550.svg";